const metricsColors = {
  CYCLE: '#1DBADF',
  MODEL: '#873679',
  PLAN: '#00B197',
  AREA: 'rgba(135, 54, 121, 0.15)',
  NASA: '#db973a'
};

export default metricsColors;
